
import './style.scss';
import { useRef, useCallback, useEffect } from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import { ArrowBack, Delete, Edit, ImageOutlined } from '@mui/icons-material';
import useState from '../../hooks/useState';


interface IImageFieldProps {
    title?: string;
    name: string;
    alt?: string;
    defaultImage?: string;
    height: number;
    disabled?: boolean;
    required?: boolean;
    className?: string;
}

interface IStateValues {
    image: string | undefined;
    validator: boolean;
}


const ImageField: React.FC<IImageFieldProps> = ({
    title = undefined,
    name,
    alt = undefined,
    defaultImage = undefined,
    height,
    disabled = false,
    required = true,
    className = ''
}) => {
    const state = useState<IStateValues>({
        image: defaultImage,
        validator: false
    });

    const imageInputRef = useRef<HTMLInputElement | null>(null);


    useEffect(() => {
        state.reset();
        // eslint-disable-next-line
    }, [defaultImage]);


    const clearImageInput = useCallback(() => {
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    }, [imageInputRef]);

    return (
        <>
            <Box className={`imagefield-default ${className}`} sx={{ height: height }}>
                {
                    title && <Typography variant='subtitle1' className='text-title'>{title}</Typography>
                }

                <Avatar alt={alt ?? `imagefield-${name}`} src={state.values.image} className='avatar-image'>
                    {
                        alt === undefined ? (
                            <ImageOutlined fontSize='large' />
                        ) : (
                            alt.charAt(0)
                        )
                    }
                </Avatar>

                <Box className='box-avataractions'>
                    {
                        !disabled && <>
                            {
                                state.values.validator && (
                                    <IconButton
                                        className='iconbutton-action'
                                        onClick={() => {
                                            state.reset();
                                            clearImageInput();
                                        }}
                                    >
                                        <ArrowBack className='icon-action' />
                                    </IconButton>
                                )
                            }

                            <IconButton className='iconbutton-action' onClick={() => imageInputRef.current && imageInputRef.current.click()}>
                                <Edit className='icon-action' />
                            </IconButton>

                            <IconButton
                                className='iconbutton-action'
                                onClick={() => {
                                    state.update('image', alt);
                                    state.update('validator', true);
                                    clearImageInput();
                                }}
                            >
                                <Delete className='icon-action' />
                            </IconButton>
                        </>
                    }
                </Box>

                <input
                    type='text'
                    name={`${name}Validator`}
                    value={state.values.validator.toString()}
                    className='display-none'
                />

                <input
                    ref={imageInputRef}
                    type='file'
                    accept='image/*'
                    multiple={false}
                    name={name}
                    className='display-none'
                    disabled={disabled}
                    required={required}
                    onChange={e => {
                        if (e.target.files && e.target.files.length > 0) {
                            state.update('image', URL.createObjectURL(e.target.files[0]));
                        }

                        state.update('validator', true);
                    }}
                />
            </Box>
        </>
    );
}

export default ImageField;